<template>
  <div :class="dataStyle">
    <img :src="dataImg" class="tc pr12" v-if="dataImg"/>
    <p class="fs-12 tc" :class="dataTextColor">{{ dataText }}</p>
  </div>
</template>
<script>
export default {
  name: "ToastMsg",
  props: ["dataText", "dataImg", "dataStyle","dataTextColor"],
};
</script>
